import { useEffect } from "react";
import { useState } from "react";
import CasosBack from "./CasosBackoffice";
import NewsBack from "./NewsBackoffice";
import "./styles/Backoffice.css"
import { newsActions, casosActions } from "../service.js"



function Backoffice(props) {

    const [casos, setCasos] = useState()
    const [news, setNews] = useState()
    const [user, setUser] = useState()
    const [option, setOption] = useState(true)

    useEffect(() => {
        let userS = localStorage.getItem("token")
        if (!userS) window.location.replace("/login")
        else setUser(userS)
        casosActions.get().then(res => setCasos(res))
        newsActions.get().then(res => setNews(res))
    }, [])


    return (
        <>
            {
                user &&
                < main className="mainBackoffice">
                    <button className="btnSend" onClick={() => {
                        localStorage.removeItem("token")
                        window.location.replace("/")
                    }}>log-out</button>
                    <label className="switch">
                        <input className="inputCheck" type="checkbox" onClick={() => setOption(!option)} />
                        <span className="slider"></span>
                    </label>
                    <h2>Carga de datos</h2>
                    {option ? (
                        <CasosBack setCasos={setCasos} casos={casos ? casos : []} />
                    ) : (
                        <NewsBack setNews={setNews} news={news} />
                    )}
                </main>
            }
        </>
    )
}

export default Backoffice